import { fetchWithAuth, getAuthStore } from '@/lib/api/client';
export { createRemoteWorkTask } from './remoteWork.js';
export const MAC_PROJECT_WEB_NOTICE = 'This chat is connected to a folder on your Mac. Read it here, and continue in the Gab AI Mac app or from Remote on your paired phone.';
export async function withRemoteWorkTask(task, send) {
  if (task?.localProject?.bindingId) throw new Error(MAC_PROJECT_WEB_NOTICE);
  const id = String(task?.id || task?._id || '');
  if (!/^[a-f0-9]{24}$/.test(id)) throw new Error('Open this Work chat again.');
  const auth = getAuthStore().getState(), generation = auth._sessionGeneration, userId = auth.user?.id;
  const current = () => {
    const state = getAuthStore().getState();
    return !!state.token && !state._isSigningOut && state.user?.id === userId && state._sessionGeneration === generation;
  };
  const latest = await fetchWithAuth(`/json/tasks/${id}`, { isRequestCurrent: current });
  // Paused/failed tasks include their saved error text in successful detail
  // responses. Only the boolean API error envelope means the lookup failed;
  // saved failure text must not block Resume, follow-ups, or settings changes.
  if (!current() || latest?.error === true || String(latest?.id || latest?._id || '') !== id) throw new Error('Open this Work chat again.');
  if (latest.localProject?.bindingId) throw new Error(MAC_PROJECT_WEB_NOTICE);
  return send({ isRequestCurrent: current });
}
